__turbopack_context__.v({
  "bg": "PlansBenefits-module-scss-module__kjpoxq__bg",
  "grid": "PlansBenefits-module-scss-module__kjpoxq__grid",
  "item": "PlansBenefits-module-scss-module__kjpoxq__item",
});
